<template>

    <form @submit.prevent="login" class="login-form">
        <div id="message" class="error mb-3" v-if="errormsg">{{errormsg}}</div>
        <div class="form-group">
            <!-- <label for="user_name">User Name</label> -->
            <input id="user_name" v-model="user.user_name" :placeholder="$t('User Name')" class="form-control" required
                type="text" autofocus/>
        </div>

        <div class="form-group">
            <!-- <label for="password">Password</label> -->
            <input id="password" v-model="user.password" class="form-control" placeholder="Password" required
                type="password" />
        </div>

        <div class="form-group" v-if="showCaptcha">
            <label for="captcha">Captcha</label>
            <input id="captcha" type="text" class="form-control" v-model="user.captcha" required>

        </div>
        <div class="mt-2 captcha d-flex justify-content-between align-items-center" v-if="showCaptcha">
            <img :src="captchaImageUrl" alt="CAPTCHA">
            <button type="button" @click="reloadCaptcha"><i class="fa-solid fa-rotate-right"></i></button>
        </div>


        <div class="form-group  mt-4 mb-3">
            <div class="d-flex justify-content-end align-items-center">
                <!-- <router-link to="/auth/reset">FORGOT PASSWORD</router-link> -->
                <button id="submit-login" class="btn btn-button" type="submit"> Sign In</button>
            </div>

        </div>



    </form>

</template>

<script>
    export default {
        name: "login",
        data() {
            return {
                user: {
                    user_name: null,
                    password: null,
                    captcha: null,
                },
                showCaptcha: false,
                captchaRandom: Math.random(),
                errormsg: null,
            }
        },
        mounted() {
            // Retrieve the CAPTCHA show/hide setting from Laravel
            this.showCaptcha = document.querySelector('meta[name="captcha-status"]').getAttribute('content');
            this.updateCsrfToken();

        },
        computed: {
            captchaImageUrl() {
                return `/captcha/default?${this.captchaRandom}`;
            },
        },
        methods: {
            reloadCaptcha() {
                this.captchaRandom = Math.random(); // Generate new random value to reload CAPTCHA image
            },
            updateCsrfToken() {
                return axios.get('/api/csrf-token')
                    .then(response => {
                        const csrfToken = response.data.csrf_token;
                        const metaTag = document.querySelector('meta[name="csrf-token"]');
                        metaTag.setAttribute('content', csrfToken);
                        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
                    })
                    .catch(error => {
                        // Handle error
                    });
            },
            login() {
                const errorMessages = document.getElementsByClassName('error-message');
                while (errorMessages.length > 0) {
                    errorMessages[0].remove();
                }
                const self = this;
                self.errormsg = false;
                self.updateCsrfToken().then(function () {
                axios.post('api/auth/login', self.user).then(function (response) {
                    self.errormsg = response.data.message
                    if (response.data.two_fa_status == 'Yes') {
                        self.$router.push('/auth/verify-otp');
                    } else {
                        self.$store.commit('login', response.data);
                        self.$router.push('/modules/home');
                    }
                }).catch(function () {
                    self.loading = false;
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                    Object.keys(err_msg2 || {}).forEach((key) => {
                        let errorval = err_msg2[key];
                        const input = document.getElementById(key);
                        const errorDiv = document.createElement('span');
                        errorDiv.className = 'error d-block mt-2';
                        errorDiv.textContent = errorval;
                        input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                    });
                    localStorage.removeItem('Errors');
                    self.user.password = null;
                    self.reloadCaptcha();
                });
                });
            },
        }
    }
</script>